import React from 'react';
import { formatDate } from '../../lib/libraryUtils';

/**
 * Audit log view component
 */
const AuditView = ({ events, loading }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        <span className="text-4xl">📋</span>
        <p className="mt-2">Geen audit logs gevonden</p>
      </div>
    );
  }

  const getActionIcon = (action) => {
    const icons = {
      'UPLOAD': '📤',
      'DOWNLOAD': '📥',
      'DELETE': '🗑️',
      'RESTORE': '♻️',
      'PERMANENT_DELETE': '💀',
      'EMPTY_TRASH': '🧹',
      'MOVE': '📦',
      'RENAME': '✏️',
      'CREATE_FOLDER': '📁',
    };
    return icons[action] || '📝';
  };

  const getActionLabel = (action) => {
    const labels = {
      'UPLOAD': 'Upload',
      'DOWNLOAD': 'Download',
      'DELETE': 'Naar prullenbak',
      'RESTORE': 'Hersteld',
      'PERMANENT_DELETE': 'Permanent verwijderd',
      'EMPTY_TRASH': 'Prullenbak geleegd',
      'MOVE': 'Verplaatst',
      'RENAME': 'Hernoemd',
      'CREATE_FOLDER': 'Map aangemaakt',
    };
    return labels[action] || action;
  };

  return (
    <div className="space-y-2">
      {events.map((event, index) => (
        <div 
          key={event.id || index}
          className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg"
          data-testid={`audit-event-${index}`}
        >
          <span className="text-xl">{getActionIcon(event.action)}</span>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-medium text-sm">
                {getActionLabel(event.action)}
              </span>
              <span className="text-xs text-gray-400">
                door {event.actor_username}
              </span>
            </div>
            {event.metadata && (
              <div className="text-xs text-gray-500 mt-1">
                {event.metadata.filename && (
                  <span className="mr-2">📄 {event.metadata.filename}</span>
                )}
                {event.metadata.title && !event.metadata.filename && (
                  <span className="mr-2">📄 {event.metadata.title}</span>
                )}
                {event.metadata.was_compressed && (
                  <span className="text-orange-600">
                    (gecomprimeerd: {Math.round(event.metadata.original_size / 1024)}KB → {Math.round(event.metadata.compressed_size / 1024)}KB)
                  </span>
                )}
              </div>
            )}
            <div className="text-xs text-gray-400 mt-1">
              {formatDate(event.created_at)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditView;
